// productsData.js
import cloverMiniImg from "../../assets/tile-clover-mini.png";
import cloverFlexImg from "../../assets/tile-clover-flex.png";
import cloverStationImg from "../../assets/tile-clover-station.png";
import cloverStationDuoImg from "../../assets/tile-clover-station-pro.png";
import PaxImg from "../../assets/pax.png";

export const PRODUCTS = [
  {
    id: "PaxA920",
    name: "Pax A920",
    subtitle: "0% Credit Card Processing",
    priceNow: 20,
    priceWas: 69.99,
    imageUrl: PaxImg,
    description: "Sophisticated merchant services in a compact standalone countertop device",
    bullets: [
      "Accept all payment types",
      "Get deposits fast and easy",
      "All-in-one system. WiFi and LTE connectivity",
      "Manage your business from anywhere",
    ],
    bestFits: ["Quick-service Restaurants", "Retailers", "Services"],
    specs: [
      "Touchscreen display",
      "WiFi & LTE connectivity",
      "Compact all-in-one design",
      "Accept all payment types",
    ],
    pricing: [
      {
        label: "Visa, Mastercard, Discover, American Express, effective rate with Cash Discount Program",
        rate: "0.00%",
        showIcons: true,
      },
      { label: "Transaction Fee", rate: "$0.00" },
      { label: "Setup Fee, Cancellation Fee", rate: "$0.00" },
      { label: "Monthly Service Fee", rate: "$20.00" },
      { label: "TransArmor Encryption Monthly Fee", rate: "$0.00" },
      { label: "Pax Services Monthly Fee", rate: "$0.00" },
      { label: "Total Equipment Cost", rate: "$0.00" },
    ],
  },
  {
    id: "clover-flex",
    name: "Clover Flex POS",
    subtitle: "0% Credit Card Processing",
    priceNow: 20,
    priceWas: 90.99,
    imageUrl: cloverFlexImg,
    description: "Sophisticated merchant services in a compact standalone countertop device",
    bullets: [
      "Accept all payment types",
      "Get deposits fast and easy",
      "All-in-one system. WiFi and LTE connectivity",
      "Manage your business from anywhere",
    ],
    bestFits: ["Quick-service Restaurants", "Retailers", "Services"],
    specs: [
      "5\" full HD touch screen",
      "WiFi & LTE connectivity",
      "Built-in receipt printer",
      "Portable handheld design",
    ],
    pricing: [
      {
        label: "Visa, Mastercard, Discover, American Express, effective rate with Cash Discount Program",
        rate: "0.00%",
        showIcons: true,
      },
      { label: "Transaction Fee", rate: "$0.00" },
      { label: "Setup Fee, Cancellation Fee", rate: "$0.00" },
      { label: "Monthly Service Fee", rate: "$10.00" },
      { label: "TransArmor Encryption Monthly Fee", rate: "$10.00" },
      { label: "Clover Monthly Service Fee", rate: "$0.00" },
      { label: "Total Equipment Cost", rate: "$0.00" },
    ],
  },
  {
    id: "clover-mini",
    name: "Clover Mini POS",
    subtitle: "0% Credit Card Processing",
    priceNow: 30,
    priceWas: 119.99,
    imageUrl: cloverMiniImg,
    description: "The POS that's small enough to fit into any space but powerful enough to run business",
    bullets: [
      "Full-featured tools for your business",
      "Swipe, dip, tap, or take cash—accept all the ways",
      "Access your data anywhere you need",
      "All-in-one system. WiFi or WiFi/LTE connectivity",
    ],
    bestFits: ["Retailers", "Grocery Stores", "Quick-Service Restaurants"],
    specs: [
      "7\" touchscreen display",
      "WiFi or WiFi/LTE connectivity",
      "Customer-facing display",
      "Space-saving countertop design",
    ],
    pricing: [
      {
        label: "Visa, Mastercard, Discover, American Express, effective rate with Cash Discount Program",
        rate: "0.00%",
        showIcons: true,
      },
      { label: "Transaction Fee", rate: "$0.00" },
      { label: "Setup Fee, Cancellation Fee", rate: "$0.00" },
      { label: "Monthly Service Fee", rate: "$20.00" },
      { label: "TransArmor Encryption Monthly Fee", rate: "$10.00" },
      { label: "Clover Monthly Service Fee", rate: "$0.00" },
      { label: "Total Equipment Cost", rate: "$0.00" },
    ],
  },
  {
    id: "clover-station-duo",
    name: "Clover Station Duo",
    subtitle: "0% Credit Card Processing",
    priceNow: 59,
    priceWas: 239.99,
    imageUrl: cloverStationDuoImg,
    description: "A POS that does it all",
    bullets: [
      "A screen for you, another for your customer",
      "Receipt printer, cash drawer, connectivity hub",
      "Online ordering, Inventory, Discounts, Employee Management…",
      "Contactless & traditional payments, paperless receipts, offline mode",
    ],
    bestFits: ["Retailers", "Counter-service restaurants", "Appointments & services"],
    specs: [
      "14\" touch screen",
      "Full cash drawer",
      "Barcode scanner",
      "Customer display",
    ],
    pricing: [
      {
        label: "Visa, Mastercard, Discover, American Express, effective rate with Cash Discount Program",
        rate: "0.00%",
        showIcons: true,
      },
      { label: "Transaction Fee", rate: "$0.00" },
      { label: "Setup Fee, Cancellation Fee", rate: "$0.00" },
      { label: "Monthly Service Fee", rate: "$20.00" },
      { label: "TransArmor Encryption Monthly Fee", rate: "$10.00" },
      { label: "Clover Monthly Service Fee", rate: "$29.00" },
      { label: "Total Equipment Cost", rate: "$0.00" },
    ],
  },
];
